// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2quUd","notes":"Notes_notes__3lCDJ","note":"Notes_note__16371","markdown":"Notes_markdown__1ASVh"};